import { Button, padding, pxToRem, unit, themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Container = styled.div `
  ${padding(4, 0)};
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${unit(2)};

  &:not(:last-of-type) {
    border-bottom: solid ${pxToRem(1)} ${themeGet('colors.gray.50')};
  }
`;
export const LeftCell = styled.div `
  display: flex;
  align-items: center;
  flex: 1 1 auto;

  cursor: ${({ $pending }) => !$pending && 'pointer'};
`;
export const RightCell = styled.div `
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  gap: ${themeGet('spacing.xs')};
`;
export const StyledButton = styled(Button) `
  height: ${pxToRem(34)};
`;
